const daysCountdown = (timestamp: number): number => {
  const days = (timestamp - new Date().getTime()) / (1000 * 60 * 60 * 24);

  // fix floating point precision issue, also make sure it's not negative
  return Math.max(0, Math.round(days));
};

export default daysCountdown;
